export const NULL = 'is_null' // 为空
export const NOT_NULL = 'not_null' // 不为空

export const INCLUDED = 'like' // 包含
export const NOT_INCLUDED = 'not_like' // 未包含

export const EQ = 'eq' // 等于
export const NOT_EQ = 'not_eq' // 不等于

export const GT = 'gt' //大于
export const GE = 'ge' // 大于等于

export const LT = 'lt' // 小于
export const LE = 'le' // 小于等于

export const BETWEEN = 'between' // 介于
export const NOT_BETWEEN = 'not_between' // 不介于

export const IN = 'in' // 选中
export const NOT_IN = 'not_in' // 未选中
